import { routerPostCall } from '../../axios';

const getPremuim = (state, params, url) => {
  const defaultUrl = `/accounts/premium`;
  return routerPostCall(state, url || defaultUrl, params);
};
export default { getPremuim };
